import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// US-style mailbox on a wooden post, ~1.1 m: a galvanized box with a rounded
// top facing +Z, a small flag bar with a muted red flag on the side.
const WALNUT = "#7a5a3a";
const GALVANIZED = "#9aa2a6";
const STEEL = "#aab2b8";
const RED = "#b04a3a";

export const mailbox = defineModel({
  id: "mailbox",
  batchId: "modern",
  name: "Mailbox",
  tags: ["modern", "outdoor", "street", "garden", "mail", "post"],
  summary: "A US-style mailbox on a wooden post with a red flag.",
  description:
    "A US-style mailbox of the Modern Living kit: a galvanized rounded-top " +
    "box on a wooden post, door end facing +Z, with a small flag bar and a " +
    "muted red flag on the side. About 1.1 m high.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // Wooden post + cross arm carrying the box.
      {
        geometry: new THREE.BoxGeometry(0.09, 0.95, 0.09),
        color: WALNUT,
        position: [0, 0.475, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.07, 0.05, 0.4),
        color: WALNUT,
        position: [0, 0.925, 0.03],
      },
      // Box body, long axis along Z.
      {
        geometry: new THREE.BoxGeometry(0.22, 0.14, 0.46),
        color: GALVANIZED,
        position: [0, 1.02, 0.03],
      },
      // Rounded top: a half-look cylinder lying along Z.
      {
        geometry: new THREE.CylinderGeometry(0.11, 0.11, 0.46, 10),
        color: GALVANIZED,
        position: [0, 1.09, 0.03],
        rotation: [Math.PI / 2, 0, 0],
      },
      // Door plate on the +Z end, slightly proud.
      {
        geometry: new THREE.BoxGeometry(0.19, 0.12, 0.02),
        color: STEEL,
        position: [0, 1.03, 0.265],
      },
      // Flag bar and flag on the +X side.
      {
        geometry: new THREE.BoxGeometry(0.025, 0.16, 0.025),
        color: RED,
        position: [0.125, 1.14, 0.14],
      },
      {
        geometry: new THREE.BoxGeometry(0.02, 0.07, 0.12),
        color: RED,
        position: [0.125, 1.24, 0.09],
      },
    ];
  },
  animations: [],
});
